import i18n from 'live/services/i18n'
import locale from 'live/init/global-locale'

import pt_br from './i18n/pt_br'
import en_us from './i18n/en_us'

const files = {
    pt_br: pt_br,
    en_us: en_us
}

i18n.add(files[locale])